import { SlidersHorizontal } from "@phosphor-icons/react";
import clsx from "clsx";
import { useState } from "react";

import BadgeWrapper from "common/components/BadgeWrapper";
import { Button } from "common/components/ui/Button";
import {
  Drawer,
  DrawerBody,
  DrawerClose,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  DrawerTrigger,
} from "common/components/ui/Drawer";

import FiltersSelection from "./FiltersSelection";

import type {
  NavigatorFilters,
  SelectedNavigatorFilters,
} from "../../../../types";

export default function MobileFilters({
  accountId,
  isLoading,
  returnedFilters,
  selectedFilters,
  setSelectedFilters,
}: {
  accountId: string;
  isLoading: boolean;
  returnedFilters: NavigatorFilters;
  selectedFilters: SelectedNavigatorFilters;
  setSelectedFilters: (selectedFilters: SelectedNavigatorFilters) => void;
}) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Drawer open={isOpen} onOpenChange={setIsOpen}>
      <BadgeWrapper
        badgeClassName={clsx(
          "right-0 -top-0 size-4",
          !selectedFilters.length && "hidden",
        )}
      >
        <DrawerTrigger asChild>
          <Button variant="outline-black" size="lg" intent="iconOnly">
            <SlidersHorizontal />
          </Button>
        </DrawerTrigger>
      </BadgeWrapper>
      <DrawerContent>
        <DrawerHeader
          title="Filter leads"
          actionComponent={
            !!selectedFilters.length && (
              <Button
                variant="link-purple"
                onClick={() => setSelectedFilters([])}
              >
                Clear
              </Button>
            )
          }
        />
        <DrawerBody>
          <FiltersSelection
            accountId={accountId}
            isSingleColumn
            isLoading={isLoading}
            returnedFilters={returnedFilters}
            selectedFilters={selectedFilters}
            setSelectedFilters={setSelectedFilters}
          />
        </DrawerBody>
        <DrawerFooter className="justify-end">
          <DrawerClose asChild>
            <Button>Done</Button>
          </DrawerClose>
        </DrawerFooter>
      </DrawerContent>
    </Drawer>
  );
}
